
import { token, userinfo } from '@/utils/cookies'
import { VatCentre_Service_GetBasicInfo } from '@/api'

const user = {
  state: {
    token: token.get(),
    userinfo: userinfo.get(),
  },
  mutations: {
    SET_TOKEN: (state, data) => {
      state.token = data;
      token.set(data);
    },
    SET_USERINFO: (state, data) => {
      state.userinfo = data;
      userinfo.set(data);
    },
    LOGOUT: state => {
      state.token = null;
      state.userinfo = null;
      token.del();
      userinfo.del();
    }
  },
  actions: {
    SetToken: ({ commit }, token) => {
      commit('SET_TOKEN', token)
    },
    GetUserinfo: ({ commit }) => {
      VatCentre_Service_GetBasicInfo().then(data => {
        commit('SET_USERINFO', data);
      })
    },
    LogOut: ({ commit }) => {
      commit('LOGOUT');
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js